// src/features/botHealth/useBotHealth.ts
import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../../lib/api';

export interface SyncRun {
  sync_type: string;
  started_at: string;
  completed_at: string | null;
  success: boolean | null;
  items_received: number | null;
  items_saved: number | null;
  attempt_count: number;
  error_message: string | null;
}

export interface BotStatus {
  started_at: string;
  last_heartbeat_at: string;
  discord_status: string;
}

export interface GuildCounts {
  active: number;
  removed: number;
}

export interface BotHealthResponse {
  pollers: SyncRun[];
  botStatus: BotStatus | null;
  guildCounts: GuildCounts;
}

export function useBotHealth() {
  return useQuery({
    queryKey: ['bot-health'],
    // Moved from /api/bot-health (visible to any logged-in user) to
    // /api/creator/bot-health (2026-07-14) - Bot Health is now
    // creator-only, reusing creator.js's already-applied auth chain.
    queryFn: () => apiFetch<BotHealthResponse>('/api/creator/bot-health'),
    refetchInterval: 30_000,
  });
}
